export const TEST_EVENT_NAME = 'test_event';
export const COACH_WAITLIST_SUBMISSION = 'coach_waitlist_submission';
export const TOURNAMENT_CREATE_START = 'tournament_create_start';
export const TOURNAMENT_CREATE_PUBLISH = 'tournament_create_publish';
export const TOURNAMENT_CLICK_REGISTER_EXTERNAL = 'tournament_click_register_external';
export const TOURNAMENT_NAVIGATE_EXTERNAL = 'tournament_navigate_external';

// onboarding events
export const ONBOARDING_DEMO_WATCHED = 'onboarding.demo_watched';
export const ONBOARDING_EXAMPLE_REFLECTION_CLICKED = 'onboarding.example_reflection_clicked';
export const ONBOARDING_REMOTE_LESSON_WATCHED = 'onboarding.remote_lesson_watched';
export const ONBOARDING_CLIENTS_ADDED = 'onboarding.clients_added';
export const ONBOARDING_BANK_CONNECTED = 'onboarding.bank_connected';
export const ONBOARDING_PROFILE_COMPLETED = 'onboarding.profile_completed';
export const ONBOARDING_PRICING_SET = 'onboarding.pricing_set';
export const ONBOARDING_LISTING_SHARED = 'onboarding.listing_shared';

// Clinic events
export const CLINIC_DETAIL_MODAL_OPENED = 'clinic_detail_modal_opened';
export const CLINIC_JOIN_CLICKED = 'clinic_join_clicked';

// Google Maps API tracking events
export const GOOGLE_MAPS_API_GEOCODING = 'google_maps_api.geocoding';
export const GOOGLE_MAPS_API_GEOLOCATION = 'google_maps_api.geolocation';
export const GOOGLE_MAPS_API_AUTOCOMPLETE = 'google_maps_api.autocomplete';
export const GOOGLE_MAPS_API_PLACE_DETAILS = 'google_maps_api.place_details';
export const GOOGLE_MAPS_API_MAP_LOAD = 'google_maps_api.map_load';

// Chats events
export const COACH_REQUESTED_PLAYER_EMAIL = 'coach_requested_player_email';

// Pickleball Rating Converter tool events
export const TOOL_RATING_CONVERTER_USED = 'tool_rating_converter_used';
export const TOOL_RATING_CONVERTER_FIND_COACH_CLICKED =
  'tool_rating_converter_find_coach_clicked';
export const TOOL_RATING_CONVERTER_SIGNUP_CLICKED = 'tool_rating_converter_signup_clicked';
export const TOOL_RATING_CONVERTER_SHARE_CLICKED = 'tool_rating_converter_share_clicked';

// Pickleball Round Robin Generator tool events
export const TOOL_ROUND_ROBIN_GENERATED = 'tool_round_robin_generated';
export const TOOL_ROUND_ROBIN_REGENERATED = 'tool_round_robin_regenerated';
export const TOOL_ROUND_ROBIN_PRINTED = 'tool_round_robin_printed';
export const TOOL_ROUND_ROBIN_OPEN_IN_BOUNCE_CLICKED =
  'tool_round_robin_open_in_bounce_clicked';
export const TOOL_ROUND_ROBIN_SIGNUP_CLICKED = 'tool_round_robin_signup_clicked';

// Pickleball Bracket Generator tool events
export const TOOL_BRACKET_GENERATED = 'tool_bracket_generated';
export const TOOL_BRACKET_REGENERATED = 'tool_bracket_regenerated';
export const TOOL_BRACKET_PRINTED = 'tool_bracket_printed';
export const TOOL_BRACKET_OPEN_IN_BOUNCE_CLICKED = 'tool_bracket_open_in_bounce_clicked';
export const TOOL_BRACKET_SIGNUP_CLICKED = 'tool_bracket_signup_clicked';
